/**
 * JkdaterangeComponent
 *
 * 日期範圍選擇器組件，允許使用者選擇起始和結束日期。
 * 基於 Angular Material 的日期選擇器，提供日期範圍選擇功能，並支援雙向資料繫結和表單整合。
 *
 * @see jkdaterange.component.md 完整文檔
 */
import { Component, Input, OnInit, ViewChild, output, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
//import {MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkLib } from '../../services/jkCommon';


@Component({
  selector: 'app-jkdaterange',
  standalone: true,
  imports: [JkfieldlabelComponent, MatFormFieldModule, MatDatepickerModule, FormsModule,
    ReactiveFormsModule],// ,JsonPipe
  templateUrl: './jkdaterange.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jkdaterange.component.scss',
})
/**
 * 日期範圍選擇器組件
 * 提供起始和結束日期的選擇功能
 */
export class JkdaterangeComponent extends JkBaseComponent implements OnInit {
  /** 組件類型識別 */
  override comType: string = 'jkdaterange';

  /** 起始日期內部值 */
  _valueA: string = '';

  /**
   * 設定起始日期值
   * 自動將字串格式的日期轉換為 Date 物件
   * @param value 日期字串，格式為 'YYYY/MM/DD'
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set valueA(value: string) {
    let temp: Date | undefined = jkLib.dateField2Date(value);
    if (this._dateA !== temp) {
      this._dateA = temp; // 設_dateA 避免無限迴圈
    }
    // if(temp !== this.range.value.date1){
    //   this.range.value.date1 = temp;
    // }
    this._valueA = value;
  }

  /**
   * 取得起始日期值
   * @returns 日期字串，格式為 'YYYY/MM/DD'
   */
  get valueA(): string {
    //let r = jkLib.date2DateField(this.range.value.date1);
    let r = jkLib.date2DateField(this.dateA);
    return this._valueA;
  }

  /** 起始日期 Date 物件 */
  _dateA: Date | undefined = undefined;// string | number | Date

  /**
   * 取得起始日期 Date 物件
   * @returns 起始日期 Date 物件
   */
  get dateA(): Date | undefined {
    return this._dateA; //(this._date as any);
  }

  /**
   * 設定起始日期 Date 物件
   * 同時更新對應的字串值
   * @param d 起始日期 Date 物件
   */
  set dateA(d: Date | undefined) {
    //alert('set date d: ' + d);
    this._dateA = d;
    let v = jkLib.date2DateField(d);
    if (this._valueA !== v) { // 避免無限迴圈
      //alert('set date: ' + v);
      this._valueA = v;
    }
  }

  /** 是否顯示開啟視窗按鈕 */
  readonly showOpenWinButton = input<boolean>(true);

  /** 起始日期變更事件發射器 */
  readonly valueAChange = output<string>();

  /**
   * 處理起始日期變更事件
   * @param $event 日期變更事件
   */
  onValueAChanged($event: any) {
    //this.edA.value = newValue;
    let newValue = jkLib.date2DateField($event);
    // this.range.value.date1 = $event;
    if (this.valueAChange)
      this.valueAChange.emit(newValue);
  }

  /**
   * 處理結束日期變更事件
   * @param $event 日期變更事件
   */
  onValueBChanged($event: any) {
    //this.edA.value = newValue;
    let newValue = jkLib.date2DateField($event);
    // this.range.value.date2 = $event;
    if (this.valueBChange)
      this.valueBChange.emit(newValue);
  }

  /** 結束日期內部值 */
  _valueB: string = '';

  /**
   * 設定結束日期值
   * 自動將字串格式的日期轉換為 Date 物件
   * @param value 日期字串，格式為 'YYYY/MM/DD'
   */
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set valueB(value: string) {
    let temp: Date | undefined = jkLib.dateField2Date(value);
    if (this._dateB !== temp) {
      this._dateB = temp;
    }
    //this.range.value.date2  = temp;
    this._valueB = value;
  }

  /**
   * 取得結束日期值
   * @returns 日期字串，格式為 'YYYY/MM/DD'
   */
  get valueB(): string {
    //let r = jkLib.date2DateField(this.range.value.date2);
    return this._valueB;
  }

  /** 結束日期 Date 物件 */
  _dateB: Date | undefined = undefined;// string | number | Date

  /**
   * 取得結束日期 Date 物件
   * @returns 結束日期 Date 物件
   */
  get dateB(): Date | undefined {
    return this._dateB; //(this._date as any);
  }

  /**
   * 設定結束日期 Date 物件
   * 同時更新對應的字串值
   * @param d 結束日期 Date 物件
   */
  set dateB(d: Date | undefined) {
    //alert('set date d: ' + d);
    this._dateB = d;
    let v = jkLib.date2DateField(d);
    if (this._valueB !== v) { // 避免無限迴圈
      //alert('set date: ' + v);
      this._valueB = v;
    }
  }

  /** 結束日期變更事件發射器 */
  readonly valueBChange = output<string>();

  /** 日期範圍表單群組 */
  range = new FormGroup({
    date1: new FormControl<Date | null>(null),
    date2: new FormControl<Date | null>(null),
  });

  /**
   * 建構函數
   */
  constructor(//injector: Injector,private ref: ChangeDetectorRef,
  ) {
    super();
  }

  /**
   * 組件初始化
   */
  override ngOnInit() {
    super.ngOnInit();
  }

  /**
   * 添加日期範圍查詢條件
   * 根據起始和結束日期生成 SQL 查詢條件
   * @param where 現有的 WHERE 子句
   * @param fieldName 欄位名稱
   * @returns 添加條件後的 WHERE 子句
   */
  addWhere(where: string, fieldName: string): string {
    //  TODO:
    let valueA = this.valueA; //jkLib.date2DateField(this.range.value.date1);
    let valueB = this.valueB; //jkLib.date2DateField(this.range.value.date2);
    if (this.required() && (valueA === '' || valueB === '')) {
      let msg = this.label() + ' 不可空白';
      alert(msg);
      throw new Error(msg);
    }
    where = jkLib.range2Where(valueA, valueB, where, fieldName);
    return where;
  }
}

